module.exports = __webpack_public_path__ + "img/price.09c853e8.png";